import { bov3_api } from '../..';
import { PropertyType } from '../../../common';

export const setPartnerGames = (data: PropertyType): Promise<PropertyType> =>
	bov3_api
		.post(``, {
			sid: data.token,
			partner_id: data.partner_id,
			game_ids: data.game_ids,
			action: data.action || 'replace',
			request: 'SetPartnerGames',
		})
		.then((res) => {
			if (res.data?.resultCode !== 0) {
				throw new Error(res.data?.errorMessage || 'Failed to set partner games');
			}
			return res.data;
		});
